/// SWPIER              ////////
// import Swiper bundle with all modules installed
import Swiper from 'swiper/bundle';
import 'swiper/css/bundle';

// // スライド番号の切り替え
const updateFraction = (elmClassName, index) => {
  // let activeSlide = document.getElementById(elmName).children[index];
  let activeSlide = document.querySelectorAll(elmClassName)[index];
  //console.log(activeSlide);
  //console.log(index);
  activeSlide.classList.add('active');
};

//activeを削除
function removeFunc(elmClassName) {
  let slides = document.querySelectorAll(elmClassName);
  // console.log(slides.length);
  slides.forEach((slide) => {
    slide.classList.remove('active');
    //  console.log('remove ok');
  });
}

let mySwiper1 = new Swiper('.sam-nord-swiper', {
  on: {
    slideChange: (swiper) => {
      console.log('現在のスライド番号： ' + (swiper.realIndex + 1));
      removeFunc('#series_detail_slides_sam .series_detail_slide');
      updateFraction(
        '#series_detail_slides_sam .series_detail_slide',
        swiper.realIndex
      );
    },
  },

  // 以下にオプションを設定
  loop: false,
  watchSlidesProgress: true,
  slidesPerView: 3,
  centeredSlides: true,
  spaceBetween: 0,
  preloadImages: false,
  lazy: true,
  navigation: {
    nextEl: '.series_detail_img_btn--next',
    prevEl: '.series_detail_img_btn--prev',
  },
});

let mySwiper2 = new Swiper('.pell-swiper', {
  on: {
    slideChange: (swiper) => {
      console.log('現在のスライド番号： ' + (swiper.realIndex + 1));
      removeFunc('#series_detail_slides_pell .series_detail_slide');
      updateFraction(
        '#series_detail_slides_pell .series_detail_slide',
        swiper.realIndex
      );
    },
  },

  // 以下にオプションを設定
  loop: false,
  watchSlidesProgress: true,
  slidesPerView: 3,
  centeredSlides: true,
  spaceBetween: 0,
  preloadImages: false,
  lazy: true,
  navigation: {
    nextEl: '.series_detail_img_btn--next',
    prevEl: '.series_detail_img_btn--prev',
  },
});

let mySwiper3 = new Swiper('.pol-swiper', {
  on: {
    slideChange: (swiper) => {
      //  console.log('現在のスライド番号： ' + (swiper.realIndex + 1));
      removeFunc('#series_detail_slides_pol .series_detail_slide');
      updateFraction(
        '#series_detail_slides_pol .series_detail_slide',
        swiper.realIndex
      );
    },
  },

  // 以下にオプションを設定
  loop: false,
  watchSlidesProgress: true,
  slidesPerView: 3,
  centeredSlides: true,
  spaceBetween: 0,
  preloadImages: false,
  lazy: true,
  navigation: {
    nextEl: '.series_detail_img_btn--next',
    prevEl: '.series_detail_img_btn--prev',
  },
});
let mySwiper4 = new Swiper('.bms-swiper', {
  on: {
    slideChange: (swiper) => {
      //console.log('現在のスライド番号： ' + (swiper.realIndex + 1));
      removeFunc('#series_detail_slides_bms .series_detail_slide');
      updateFraction(
        '#series_detail_slides_bms .series_detail_slide',
        swiper.realIndex
      );
    },
  },

  // 以下にオプションを設定
  loop: false,
  watchSlidesProgress: true,
  slidesPerView: 3,
  centeredSlides: true,
  spaceBetween: 0,
  preloadImages: false,
  lazy: true,
  navigation: {
    nextEl: '.series_detail_img_btn--next',
    prevEl: '.series_detail_img_btn--prev',
  },
});
